import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CheckIcon, XIcon, WarningIcon } from '../../icons';
import { cn } from '../../utils';
import { ElementIntent } from '../../enums';
const getIntentStyles = (intent) => {
    switch (intent) {
        case ElementIntent.Success:
            return {
                iconBg: 'bg-green-400',
                iconOutline: 'outline-green-200',
                iconColor: 'text-green-800',
                icon: CheckIcon,
            };
        case ElementIntent.Danger:
            return {
                iconBg: 'bg-red-400',
                iconOutline: 'outline-red-200',
                iconColor: 'text-red-800',
                icon: XIcon,
            };
        case ElementIntent.Warning:
            return {
                iconBg: 'bg-yellow-400',
                iconOutline: 'outline-yellow-200',
                iconColor: 'text-yellow-800',
                icon: WarningIcon,
            };
        case ElementIntent.Info:
        default:
            return {
                iconBg: 'bg-blue-400',
                iconOutline: 'outline-blue-200',
                iconColor: 'text-blue-800',
                icon: WarningIcon,
            };
    }
};
export function Toast({ intent, title, message, onDismiss }) {
    const styles = getIntentStyles(intent);
    return (_jsx("div", { className: "bg-white p-4 border border-gray-50 rounded-2xl shadow-lg max-w-sm", children: _jsxs("div", { className: "flex items-center gap-3", children: [_jsx("div", { className: cn('flex-shrink-0 size-8', 'rounded-xl flex items-center justify-center', styles.iconBg, styles.iconOutline), children: _jsx("span", { className: styles.iconColor, children: _jsx(styles.icon, { className: "size-4" }) }) }), _jsxs("div", { children: [_jsx("p", { className: "text-gray-900 text-sm font-semibold", children: title }), _jsx("p", { className: "text-gray-700 text-xs", children: message })] }), _jsx("button", { onClick: onDismiss, className: "p-2 rounded-full hover:bg-gray-50/50", children: _jsx(XIcon, { className: "w-4 h-4 text-gray-500" }) })] }) }));
}
